import { useContext } from 'react';
import StoresContext from '../contexts/root-store';

const useStores = () => useContext(StoresContext);

export default useStores;
